<script lang="ts">
	import { Phone, Ellipsis } from 'lucide-svelte/icons';

	import Button from './ui/button/button.svelte';

	import Megamenu from './nav/Megamenu.svelte';
	import Planner from './nav/Planner.svelte';

	import Mobilenav from './nav/Mobilenav.svelte';
	import Search from './nav/Search.svelte';
	import Links from './nav/Links.svelte';
</script>

<header
	class="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60"
>
	<div class="mx-auto flex h-14 max-w-screen-2xl items-center px-4">
		<div class="mr-4 hidden xl:flex">
			<a data-sveltekit-noscroll href="/" class="mr-6 flex items-center space-x-2">
				<enhanced:img
					src="/src/lib/assets/logo/logo-black.png?w=144;96"
					alt="Tassie Tours Logo"
					class="h-12 w-auto"
					sizes="(min-width: 1280px) 144px, 96px"
					fetchpriority="high"
				/>
			</a>
			<Megamenu />
		</div>
		<div class="flex flex-1 items-center justify-between space-x-2 xl:justify-end">
			<Mobilenav />
			<a data-sveltekit-noscroll href="/" class="mr-6 flex items-center space-x-2 xl:hidden">
				<enhanced:img
					src="/src/lib/assets/logo/logo-black.png?w=144;96"
					alt="Tassie Tours Logo"
					class="h-12 w-auto"
					sizes="(min-width: 1280px) 144px, 96px"
					fetchpriority="high"
				/>
			</a>
			<div class="hidden w-full flex-1 xl:flex xl:w-auto xl:flex-none">
				<Search />
			</div>
			<Button
				href="/tours#dayTours"
				data-sveltekit-noscroll
				class="hidden rounded-full bg-tt-red font-semibold hover:bg-tt-red/90 xl:flex"
				>Book now</Button
			>
			<nav class="flex items-center">
				<!-- <Links /> -->
				<Planner />
				<!-- <Translate /> -->
				<Button
					class="relative h-8 w-8 rounded-full px-0"
					href="/contact"
					variant="ghost"
					size="icon"
				>
					<Phone class="h-4 w-4" />
					<span class="sr-only">Contact</span>
				</Button>
			</nav>
		</div>
	</div>
</header>
